import { render, staticRenderFns } from "./BoilerplateComposer.vue?vue&type=template&id=53a316ec&scoped=true&"
import script from "./BoilerplateComposer.vue?vue&type=script&lang=js&"
export * from "./BoilerplateComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a316ec",
  null
  
)

export default component.exports